import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, IcoShortArrowRight } from "components/generic";
import { InputMessage, InputMessageSection } from "./styles";

export const MessageInput: React.FC<{
    activeConvId: string;
    currentNoChatId: string;
    setCurrentNoChatId: (id: string) => void;
    setMessageData: (newMsg: string) => void;
    isPhone?: boolean;
    noChatId: boolean;
    setIsInChat: (isInChat: boolean) => void
    socketRef: React.MutableRefObject<WebSocket | null> | null
} & React.HTMLAttributes<HTMLDivElement>> = ({ setMessageData, activeConvId, setCurrentNoChatId, currentNoChatId, isPhone, setIsInChat, noChatId, socketRef, ...props }) => {
    const { t } = useTranslation("chats");

    const [newMessage, setNewMessage] = useState("");

    const onInputChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setIsInChat(true)
        setNewMessage(e.currentTarget.value);
    };

    const sendMessageHandler = () => {
        console.log(newMessage)
        setMessageData(newMessage);
        setNewMessage("");
    };

    useEffect(() => {
        (noChatId && !currentNoChatId) && setCurrentNoChatId(activeConvId)
    }, [activeConvId, noChatId])

    const handleEnter = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && newMessage.trim()) {
            sendMessageHandler();
            e.preventDefault();
        }
    };

    return (
        <InputMessageSection {...props}>
            <InputMessage
                placeholder={isPhone ? "Message" : t("editPlaceholder")}
                onChange={onInputChangeHandler}
                value={newMessage}
                onKeyPress={handleEnter}
            />
            <Button
                main
                h={"37px"}
                fontSize={"16px"}
                title={!socketRef?.current ? t('badConnection') : ''}
                disabled={(activeConvId === currentNoChatId) || !newMessage || !socketRef?.current}
                onClick={sendMessageHandler}
            >
                {isPhone ? "" : t("send")}
                <IcoShortArrowRight size={"2em"} />
            </Button>
        </InputMessageSection>
    );
};
